import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativeHoursBelow45FSEP: typeof valueTypeRenderers.chillCumulativeHoursBelow45FSEP = {
  label: () => unitConverter.chillCumulativeHoursBelow45FSEP().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativeHoursBelow45FSEP().title(),
      render: (n) => unitConverter.chillCumulativeHoursBelow45FSEP(n).valueAsString(),
    }),
}
